import { createSelector } from '@reduxjs/toolkit';
import { includes } from 'lodash';

const subscriptionSelector = (slug: any) => (state: any, props: any) => {
  const subscriptions = Object.values(state.subscriptions.data);
  return subscriptions.find(
    (subscription: any) =>
      subscription.slug === (slug || props.subscriptionType),
  );
};

const subscriptionsSelector = (state: any, props: any) => {
  const subscriptions = Object.values(state.subscriptions.data);
  return subscriptions.filter(
    (subscription: any) =>
      includes(props.subscriptionTypes, subscription.slug) ||
      !props.subscriptionTypes,
  );
};

export const isSubscriptionOnTrialFactory = (slug: any) =>
  createSelector(
    subscriptionSelector(slug),
    (subscription: any) => !!subscription?.on_trial,
  );

export const isSubscriptionActiveFactory = (slug: any) =>
  createSelector(subscriptionSelector(slug), (subscription: any) => {
    return !!subscription?.active;
  });

export const isSubscriptionInactiveFactory = (slug: any) =>
  createSelector(
    subscriptionSelector(slug),
    (subscription: any) => !!subscription?.inactive,
  );

export const isSubscriptionsInactiveFactory = () =>
  createSelector(subscriptionsSelector, (subscriptions: any) =>
    subscriptions.some((subscription: any) => subscription?.inactive),
  );

export const isSubscriptionsActiveFactory = () =>
  createSelector(subscriptionsSelector, (subscriptions: any) =>
    subscriptions.some((subscription: any) => subscription?.active),
  );
